import React from 'react';

export const SponsorBanner = ({ sponsorProfile }) => {
  if (!sponsorProfile) return null;

  const { firstName, photoUri } = sponsorProfile;
  if (!firstName) return null;

  return (
    <div className="sponsor-banner">
      <div className="sponsor-banner-photo-ring">
        {photoUri ? (
          <img
            src={photoUri}
            alt={`${firstName}'s profile`}
            className="sponsor-banner-photo"
          />
        ) : (
          <div className="sponsor-banner-photo-placeholder" aria-label={`${firstName}'s profile`}>
            {firstName.charAt(0).toUpperCase()}
          </div>
        )}
      </div>
      <h2 className="sponsor-banner-text">
        Join {firstName} to get more repeat and referral business
      </h2>
    </div>
  );
};

